<template>
  <div id="data-list-thumb-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />
    <vs-popup
      class="holamundo"
      title="Gider Tipi Sil"
      :active.sync="deletePopupActive"
      v-esc="escape"
    >
      <vs-row vs-type="flex" vs-w="12">
        <p>Bu Gider Tipini Silmek İstediğinize Eminmisiniz ?</p>
      </vs-row>
      <vs-row vs-type="flex" vs-w="12" class="mt-3" vs-justify="space-between">
        <vs-button
          type="gradient"
          color="primary"
          @click="
            deletePopupActive = false;
            deletedId = null;
          "
          >Vazgeç</vs-button
        >
        <vs-button
          type="gradient"
          color="danger"
          icon-pack="feather"
          icon="icon-trash"
          @click="deleteData(deletedId)"
        >
          Sil
        </vs-button>
      </vs-row>
    </vs-popup>
    <vs-table
      ref="table"
      :data="expenseDefinitions"
      :max-items="itemsPerPage"
      v-model="selected"
    >
      <div
        slot="header"
        class="w-full flex flex-wrap items-center flex-grow justify-between"
      >
        <vs-row
          id="panelHeaderRow"
          v-show="!isFilterActive"
          vs-type="flex"
          vs-w="12"
          vs-justify="space-between"
        >
          <vs-col
            id="panel-actions"
            vs-type="flex"
            class="w-auto"
            vs-justify="center"
          >
            <vs-row vs-type="flex" vs-w="12">
              <vs-col v-if="$isCenterBranch() || $isRegionalCenterBranch()" vs-type="flex" class="w-auto">
                <vx-tooltip text="Yeni Gider Tipi" position="top">
                  <vs-button
                    @click="addNewData"
                    class="panel-action text-success xlarge-button panel-action-box-shadow"
                    color="transparent"
                    icon-pack="feather"
                    icon="icon-plus"
                  >
                  </vs-button>
                </vx-tooltip>
              </vs-col>
            </vs-row>
          </vs-col>
          <vs-col
            id="table-page-size"
            vs-type="flex"
            class="w-auto"
            vs-justify="flex-end"
          >
            <vs-dropdown
              vs-trigger-click
              class="bg-white cursor-pointer panel-action-box-shadow"
            >
              <div
                class="px-4 d-theme-border-grey-light d-theme-dark-bg cursor-pointer flex items-center justify-between text-small"
              >
                <span class="mr-2 page-size-dropdown-span"
                  >{{ (currentPage + 1) * itemsPerPage - (itemsPerPage - 1) }}
                  -
                  {{
                    totalDataRow - (currentPage + 1) * itemsPerPage > 0
                      ? (currentPage + 1) * itemsPerPage
                      : totalDataRow
                  }}
                  of
                  {{ totalDataRow }}</span
                >
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="itemsPerPage = 10">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 15">
                  <span>15</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="itemsPerPage = 20">
                  <span>20</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </vs-col>
        </vs-row>
      </div>

      <template slot="thead">
        <vs-th class="w-5/12 justify-center">
          <vs-button
            icon-pack="feather"
            :icon="tableOptions.sortBy == 'name' ? sortingHeadIcon : null"
            color="primary"
            type="flat"
            @click="setSortingOptions('name')"
            >Gider Tipi
          </vs-button>
        </vs-th>
        <vs-th class="w-6/12">
          <vs-button
            icon-pack="feather"
            :icon="
              tableOptions.sortBy == 'description' ? sortingHeadIcon : null
            "
            color="primary"
            type="flat"
            @click="setSortingOptions('description')"
            >Açıklama
          </vs-button>
        </vs-th>
        <vs-th class="w-1/12" v-if="isAdmin || (AppActiveUser.branch.id == 1 && isDeleteExpenseTypePermission)">
          <vs-button
            color="primary"
            class="opacity-full"
            disabled="true"
            type="flat"
            >İşlem</vs-button
          >
        </vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody class="text-center">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td class="w-5/12">
              <p class="font-medium truncate">{{ tr.name }}</p>
            </vs-td>

            <vs-td class="w-6/12">
              <p class="font-medium truncate">{{ tr.description }}</p>
            </vs-td>

            <vs-td
              class="whitespace-no-wrap w-1/12"
              v-if="isAdmin || (AppActiveUser.branch.id == 1 && isDeleteExpenseTypePermission)"
            >
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="
                  deletedId = tr.id;
                  deletePopupActive = true;
                "
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
    <pagination-default
      :setCurrentPage="tableOptions.pageIndex"
      :totalLenght="calculatePageLength"
      @currentPage="getCurrentPage"
    ></pagination-default>
  </div>
</template>

<script>
import moduleExpenseDefinition from "@/store/expenseDefinition/moduleExpenseDefinition.js";
import PaginationDefault from "../PaginationDefault";
import DataViewSidebar from "./NewExpenseDefinitionAdd.vue";
import { removeExpenseDefinition as deleteExpenseDefinition } from "@/api/ExpenseDefinition";
import {isGranted} from "@/utils/auth";
export default {
  components: {
    DataViewSidebar,
    PaginationDefault,
  },
  data() {
    return {
      deletePopupActive: false,
      deletedId: null,
      selected: "",

      isFilterActive: false,
      tableOptions: {},
      filterColumnLabel: "",
      activeFilterDetail: false,
      sortingHeadIcon: "",
      sortingHeadIconBool: 1,
      currentPage: 0,
      itemsPerPage: 10,

      isMounted: false,
      addNewDataSidebar: false,
      sidebarData: {},
    };
  },
  computed: {
    expenseDefinitions() {
      return this.$store.state.expenseDefinition.expenseDefinitions;
    },
    totalDataRow() {
      return this.$store.state.expenseDefinition.totalDataRow;
    },
    calculatePageLength() {
      let mod = this.totalDataRow % this.itemsPerPage;
      return mod > 0
        ? (this.totalDataRow - mod) / this.itemsPerPage + 1
        : this.totalDataRow / this.itemsPerPage;
    },
    AppActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    isAdmin() {
      const user = this.$store.state.AppActiveUser;
      return user && user.role && user.role.some((x) => x.name === "admin");
    },
    isDeleteExpenseTypePermission(){
      return isGranted("expense_type_delete")
    },
  },
  methods: {
    escape() {
      if (this.deletePopupActive) {
        this.deletePopupActive = false;
        this.deletedId = null;
      }
    },
    lazyFilter: _.debounce(function (e) {
      this.tableOptions[this.tableOptions.filterColumn] =
        this.tableOptions.filterValue;
      this.tableOptions.pageIndex = 0;
      this.getExpenseDefinitionList();
    }, 600),
    setFilterColumn(column, label) {
      this.tableOptions = {
        sortBy: "",
        sortDirection: "",
        pageIndex: 0,
        pageSize: this.itemsPerPage,
        filterColumn: column,
        filterValue: "",
      };
      this.filterColumnLabel = label;
      this.getExpenseDefinitionList();
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      deleteExpenseDefinition(id).then((res) => {
        if (res && res.status == 200) {
          this.$store
            .dispatch("expenseDefinition/removeExpenseDefinition", id)
            .then((data) => {
              this.deletePopupActive = false;
              this.deletedId = null;
              this.getExpenseDefinitionList();
              this.$vs.notify({
                color: "success",
                title: "Silme İşlemi",
                text: "Gider Tipi Başarıyla Silindi",
              });
            });
        } else {
          this.$vs.notify({
            color: "danger",
            title: "Hata : " + res.status,
            text: "Silme İşlemi Başarısız !",
          });
          this.deletePopupActive = false;
          this.deletedId = null;
        }
      }).catch((error) => {
        console.error("Silme işleminde hata:", error);
        this.deletePopupActive = false;
        this.deletedId = null;
        
        let errorMessage = "Silme işlemi sırasında bir hata oluştu";
        let errorTitle = "Hata";
        
        // Backend'den gelen hata mesajını kontrol et
        if (error.response) {
          const status = error.response.status;
          const data = error.response.data;
          
          // 409 Conflict - Başka yerde kullanılıyor
          if (status === 409) {
            errorTitle = "Silinemez";
            errorMessage = "Bu gider tipi başka kayıtlar tarafından kullanıldığı için silinemez.";
            if (data && data.Message) {
              errorMessage = data.Message;
            }
          }
          // 400 Bad Request
          else if (status === 400) {
            errorTitle = "Geçersiz İstek";
            if (data && data.Message) {
              errorMessage = data.Message;
            } else if (data && data.Errors && data.Errors.length > 0) {
              errorMessage = data.Errors[0].Message;
            }
          }
          // Diğer hatalar
          else if (data) {
            if (data.Message) {
              errorMessage = data.Message;
            } else if (data.Errors && Array.isArray(data.Errors) && data.Errors.length > 0) {
              errorMessage = data.Errors[0].Message;
            }
          }
        }
        
        this.$vs.notify({
          color: "danger",
          title: errorTitle,
          text: errorMessage,
        });
      });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    getCurrentPage(currentx) {
      this.currentPage = currentx - 1;
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;
      val == false ? (this.selected = "") : null;
    },
    getExpenseDefinitionList() {
      if (!moduleExpenseDefinition.isRegistered) {
        this.$store.registerModule(
          "expenseDefinition",
          moduleExpenseDefinition
        );
        moduleExpenseDefinition.isRegistered = true;
      }
      this.$store
        .dispatch(
          "expenseDefinition/fetchDataListItemsExpenseDefinition",
          this.tableOptions
        )
        .catch((error) => {
          this.$vs.notify({
            color: "danger",
            title: "Hata",
            text: error,
          });
        });
    },
    setSortingOptions(val) {
      if (this.tableOptions.sortBy != val) this.sortingHeadIconBool = 1;
      this.tableOptions.sortBy = val;
      switch (this.sortingHeadIconBool) {
        case 1:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-up";
          break;
        case 2:
          this.sortingHeadIconBool++;
          this.sortingHeadIcon = "icon-arrow-down";
          break;
        case 3:
          this.sortingHeadIconBool = 1;
          this.sortingHeadIcon = "";
          this.tableOptions.sortBy = "";
      }
    },
  },
  created() {
    this.setFilterColumn("name", "İsim");
    document.body.addEventListener("keyup", (e) => {
      if (e.keyCode === 13) {
        if (this.deletePopupActive) this.deleteData(this.deletedId);
      }
    });
  },
  mounted() {
    this.isMounted = true;
  },
  watch: {
    selected: function (val) {
      if (val != "" && (this.$isCenterBranch() || this.$isRegionalCenterBranch()) && !val.isGlobal) this.editData(val);
    },
    currentPage: function (val) {
      this.tableOptions.pageIndex = val;
      if (this.isMounted) this.getExpenseDefinitionList();
    },
    sortingHeadIconBool: function () {
      switch (this.sortingHeadIconBool) {
        case 1:
          this.tableOptions.sortDirection = "";
          break;
        case 2:
          this.tableOptions.sortDirection = "asc";
          break;
        case 3:
          this.tableOptions.sortDirection = "desc";
          break;
      }
      this.currentPage = 0;
      this.tableOptions.pageIndex = this.currentPage;
      this.getExpenseDefinitionList();
    },
    itemsPerPage: function (val) {
      this.currentPage = 0;
      this.tableOptions.pageSize = val;
      this.tableOptions.pageIndex = this.currentPage;
      this.getExpenseDefinitionList();
    },
  },
};
</script>

<style>
.tabPager {
  background-color: darkgreen;
  border-radius: 50%;
}

.search-col .vs-con-input-label {
  width: unset !important;
}

.vs-button:not(.vs-radius):not(.includeIconOnly):not(.small):not(.large).vs-button-border {
  min-width: 10vw !important;
  flex-wrap: wrap !important;
}

#search-input {
  width: 100% !important;
  min-width: 3vw !important;
}

th .vs-table-text {
  justify-content: center !important;
  border-bottom: 0.05rem solid #d8d8d8ab !important;
  vertical-align: center !important;
  font-weight: bold !important;
}

tr button {
  font-weight: bold !important;
}
</style>
